module.exports = __webpack_public_path__ + "74e95d5d59dd8bbc41ff1cce4654bbc6.pdf";